<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <div class="header">
      <van-nav-bar :title="$t('my.sys_notice')" class="nav-bar">
        <template #left>
          <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="listItem" v-for="(v,key) in notice" :key="key">
            <div class="listTitle">{{ v.name }}</div>
            <div class="listContent html"><p>{{ v.text }}<br></p></div>
            <div class="listTime"><div class="listTimeText">{{ v.create_time }}</div></div>
          </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice:{},
      loading: false,
      finished: false,
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getNoticeList(){
      const lanng = localStorage.getItem("lang");
      this.$http({
        method: 'get',
        url: 'sys_get_notice_list'
      }).then(res=>{
        console.log(res);
        if(res.data && Array.isArray(res.data)){
          this.notice = res.data;
          this.notice.forEach(item => {
            if(item.name){
              const parts = item.name.split('|');
              if(parts.length === 1){
                item.name = parts[0];
              }else{
                item.name = lanng == 'zh' ? parts[0] : lanng == 'en' ? parts[1] : lanng == 'ja' ? parts[2] : parts[3];
              }
            }
            if(item.text){
              const textParts = item.text.split('|');
              if(textParts.length === 1){
                item.text = textParts[0];
              }else{
                item.text = lanng == 'zh' ? textParts[0] : lanng == 'en' ? textParts[1] : lanng == 'ja' ? textParts[2] : textParts[3];
              }
            }
          });
        }else{
          this.notice = [];
        }
      }).catch(err => {
        console.error('getNoticeList error:', err);
        this.notice = [];
      })
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
      }, 500);
    },
  },
  created() {
    this.getNoticeList();
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .content {
  height: calc(100% - 20px);
  overflow: auto;
}
.container .content .listItem{
  margin-bottom: 20px;
  padding: 20px 20px 0;
  position: relative;
  color: #f3c7a2;
  // background-color: #fff;
}
.container .content .listItem .listTitle{
  font-size: 38px;
}
.container .content .listItem .listContent{
  border-bottom: 2px solid #f2f2f5;
  padding: 5px 0;
  font-size: 25px;
}
.container .content .listItem .listTime{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 70px;
}
.container .content .listItem .listTime .listTimeText {
  color: #f3c7a2;
  font-size: 30px;
}
</style>
